var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9865 15.7112L10.5234 22.2258C11.186 22.2258 11.473 21.9412 11.8172 21.5993L14.924 18.6302L21.3617 23.3447C22.5424 24.0027 23.3742 23.6562 23.6927 22.2585L27.9184 2.45783L27.9195 2.45666C28.294 0.711328 27.2884 0.0288283 26.138 0.456995L1.29969 9.9665C-0.395476 10.6245 -0.369809 11.5695 1.01152 11.9977L7.36169 13.9728L22.1119 4.74333C22.806 4.28366 23.4372 4.538 22.918 4.99766L10.9865 15.7112Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8278c50f72f5dca15f86bc58c9b7fbbb.svg";
export { ForwardRef as ReactComponent };